export default __webpack_public_path__ + "/dist/images/dummy-profile-pic.jpg";